// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a334c134","654":"deb00c01","810":"a9b4e46d","949":"743b12af","963":"67445a35"}[chunkId] + ".chunk.js";
};